import getClassNameReduxUtil from '../get-class-name'

const CLASS_NAME_TO_FUNCTION = {
}

export default function shouldAddToDomainListReduxUtil (props) {
  const { instance } = props
  if (!instance) {
    return []
  }
  const className = getClassNameReduxUtil(instance)
  const fn = CLASS_NAME_TO_FUNCTION[className]
  return fn ? fn(props) : true
}
